<template>
  <div class="info-bar-wrapper" :class="{'is-visible': infoBarVisible}">
    <div class="info-bar-overlay" @click="handleClose"></div>
    <div class="info-bar">
      <button class="close" @click="handleClose"><span class="sr-only">Close</span></button>
      <div class="crop-image">
        <img :src="seedImage + '.jpg'" :srcset="seedImage + '@2x.jpg 2x'" :alt="name">
        <div class="navigation">
          <button @click="handleCropNavigation('prev')" class="btn previous"><span class="sr-only">Previous</span></button>
          <button @click="handleCropNavigation('next')" class="btn next"><span class="sr-only">Next</span></button>
        </div>
      </div>
      <div class="crop-content">
        <ratings :rating="rating" />
        <h3 class="heading-crop" v-text="name"></h3>
        <div class="cost">
          <div>
            <span class="cost-rating" :class="seedCostCategory">
              <span class="sr-only" v-text="seedCost"></span>
            </span>
            <h4 class="heading-info">Average Cost</h4>
          </div>
          <div class="value">
            <a href="#" @click.prevent="showModal = true">What's this?</a>
          </div>
        </div>
      </div>
      <div class="add-form">
        <h4 class="heading-info">Enter Seeding Rate</h4>
        <div class="add-field">
          <input class="form-control" type="text" inputmode="decimal" ref="amountField" v-model="seedingRate" @focus="handleStartEditAmount">
          <button class="toggle-units" @click="handleSelectMixUnits">
            <span v-text="mixUnits"></span><i></i>
          </button>
          <span class="toggle-label">toggle units</span>
        </div>
        <div class="alert small" v-if="amountError">Amount must be greater than 0</div>
        <div class="rate">
          <h4 class="label">Your Seeding Rate</h4>
          <span class="value">{{ actualSeedingRate }} <small>lbs/acre</small></span>
        </div>
        <div class="rate" style="opacity: .75">
          <h4 class="label">Full Seeding Rate</h4>
          <span class="value">{{ fullSeedingRate }} <small>lbs/acre</small></span>
        </div>
        <div class="add-button" :class="{'added' : showBtnSuccess}">
          <button class="btn btn-primary" @click="handleAddCrop">{{ btnText }}</button>
          <button class="remove" v-if="cropInMix" @click="handleRemoveCrop">click to remove</button>
        </div>
      </div>
      <div class="crop-content">
        <div class="crop-stats">
          <h4 class="heading-info">Ratings</h4>
          <div v-for="(value, index) in stats" :key="index">
            <stat-bar :value="value" :facetIndex="index"></stat-bar>
          </div>
        </div>
      </div>
    </div>
    <modal :shown="showModal" @close="handleHideModal" name="Average Cost">
      <p>Species are categorized by price per acre at full seeding rate.</p>
      <dl class="inline">
        <dt>Very Low ($):</dt><dd>Under $15/acre</dd>
        <dt>Low ($$):</dt><dd>$15 - $20/acre</dd>
        <dt>Medium ($$$):</dt><dd>$21 - $30/acre</dd>
        <dt>High ($$$$):</dt><dd>Over $31/acre</dd>
      </dl>
    </modal>
  </div>
</template>

<script>
import Images from '@/data/seed-images.json'
import Modal from '@/components/Modal'
import Ratings from '@/components/Ratings'
import StatBar from '@/components/StatBar'
export default {
  props: ['crop', 'amount', 'rating', 'groups', 'changed'],
  components: {
    'modal': Modal,
    'ratings': Ratings,
    'stat-bar': StatBar
  },
  data () {
    return {
      infoBarVisible: false,
      showModal: false,
      showBtnSuccess: false,
      seedimages: Images,
      mixUnits: this.$store.state.formData.mixUnits,
      amountError: false,
      btnText: 'Add to mix',
      cropInMix: false,
      seedingRate: this.amount // default passed in by species
    }
  },
  mounted () {
    this.cropInMix = this.isCropInMix()
    this.setBtnText()
    setTimeout(() => {
      this.infoBarVisible = true
    }, 100)
  },
  methods: {
    isCropInMix () {
      let isInMix = false
      this.$store.state.formData.selectedCrops.forEach((entry, index) => {
        if (entry.crop === this.crop) {
          isInMix = true
        }
      })
      return isInMix
    },
    setBtnText (event) {
      let text = 'Add to mix'
      if (this.cropInMix) {
        text = 'Update amount'
      }
      if (event === 'add') {
        text = 'Added'
      }
      if (event === 'edit') {
        text = 'Updated'
      }
      this.btnText = text
    },
    handleCropNavigation (direction) {
      let currentGroupIndex = 0
      let currentCropIndex = 0
      let cropIndexTo = 0
      // find our current location
      this.groups.forEach((group, groupsIndex) => {
        group.items.forEach((item, itemsIndex) => {
          if (item === this.crop) {
            currentGroupIndex = groupsIndex
            currentCropIndex = itemsIndex
          }
        })
      })
      let groupIndexTo = currentGroupIndex // default to staying in the same group
      if (direction === 'next') {
        cropIndexTo = currentCropIndex + 1
        // are we at the end of this list
        if (cropIndexTo > this.groups[currentGroupIndex].items.length - 1) {
          groupIndexTo = currentGroupIndex + 1
          // are we at the end of all groups
          if (groupIndexTo > this.groups.length - 1) {
            // we're at the end of everything, start at the beginning
            groupIndexTo = 0
            cropIndexTo = 0
          } else {
            // we're at the start of the next group
            cropIndexTo = 0
          }
        }
      } else {
        cropIndexTo = currentCropIndex - 1
        // are we at the beginning of this list
        if (cropIndexTo < 0) {
          groupIndexTo = currentGroupIndex - 1
          // are we at the beginning of all groups
          if (groupIndexTo < 0) {
            // we're at the beginning of everything, go to the end
            groupIndexTo = this.groups.length - 1
            cropIndexTo = this.groups[groupIndexTo].items.length - 1
          } else {
            // we're at the end of the previous group
            cropIndexTo = this.groups[groupIndexTo].items.length - 1
          }
        }
      }
      // bubble up to update the props
      this.$emit('cropChange', {
        crop: this.groups[groupIndexTo].items[cropIndexTo],
        rating: this.groups[groupIndexTo].rating
      })
    },
    handleSelectMixUnits () {
      if (this.mixUnits === '%') {
        this.mixUnits = 'lbs/acre'
        this.seedingRate = this.fullSeedingRate * this.seedingRate / 100
      } else {
        this.mixUnits = '%'
        this.seedingRate = this.seedingRate / this.fullSeedingRate * 100
      }
      this.$store.commit('updateMixUnits', this.mixUnits)
    },
    handleAddCrop () {
      this.amountError = false
      if (parseFloat(this.$refs.amountField.value) > 0) {
        this.$store.commit('addMixComponent', {
          amount: this.actualSeedingRate,
          crop: this.crop
        })
        this.$store.commit('updateMixUnits', this.mixUnits)
        if (this.cropInMix) {
          this.setBtnText('edit')
        } else {
          this.setBtnText('add')
        }
        this.showBtnSuccess = true
        this.cropInMix = true
        this.$emit('added') // updates totals
        setTimeout(() => {
          this.handleClose()
        }, 750)
      } else {
        this.amountError = true
      }
    },
    handleStartEditAmount () {
      this.showBtnSuccess = false
      this.setBtnText()
    },
    handleRemoveCrop () {
      this.amountError = false
      this.showBtnSuccess = false
      this.cropInMix = false
      this.setBtnText()
      this.$emit('removed', this.crop) // updates totals
    },
    handleHideModal () {
      this.showModal = false
    },
    handleClose () {
      this.infoBarVisible = false
      setTimeout(() => {
        this.$emit('close') // close will destroy the active crop, so it the animations finish
      }, 500)
    }
  },
  computed: {
    cropExists () {
      return Boolean(Object.keys(this.crop).length)
    },
    name () {
      return this.crop['species']
    },
    fullSeedingRate () {
      return this.crop['seedingRate']
    },
    actualSeedingRate () {
      let actualRate = this.crop['seedingRate'] * this.seedingRate / 100
      if (this.mixUnits !== '%') {
        actualRate = this.seedingRate // don't convert when we're showing lbs/acre
      }
      return Math.round(actualRate * 100) / 100
    },
    lbsAcrePrice () {
      return this.crop['pricePerLb'].replace(/\s/g, '')
    },
    seedCost () {
      return this.crop['pricePerLb'].replace(/\s/g, '') + '/lb'
    },
    seedCostCategory () {
      return this.crop['pricePerAcreCategory'].replace(/\s/g, '-').toLowerCase()
    },
    seedImage () {
      let img = this.seedimages[0][this.crop['id']]
      return img ? '/assets/seeds/' + img : '/assets/seed-placeholder'
    },
    stats () {
      return [
        this.crop['nitrogenFixationRating'],
        this.crop['grazingRating'],
        this.crop['compactionRating'],
        this.crop['salinityToleranceRating'],
        this.crop['cnRatio'],
        this.crop['scavengingRating']
      ]
    }
  },
  watch: {
    crop: function (newCrop, oldCrop) { // watch this to handle race conditions with emits
      this.showBtnSuccess = false
      this.cropInMix = this.isCropInMix()
      this.setBtnText('change')
    },
    amount: function (newAmount, oldAmount) {
      this.seedingRate = newAmount
    }
  }
}
</script>

<style lang="scss">
  .info-bar-wrapper {
    position: fixed;
    z-index: 1000;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    &.is-visible {
      pointer-events: initial;
      .info-bar-overlay{
        opacity: 1;
      }
      .info-bar{
        right: 0;
      }
    }
  }
  .info-bar-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color-green, 0.75);
    z-index: 8;
    opacity: 0;
    transition: opacity $ui-transition ease;
  }
  .info-bar {
    position: fixed;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    right: -$infobar-width-xs;
    top: 0;
    width: $infobar-width-xs;
    background: $color-dark-white;
    height: 100%;
    z-index: 9;
    transition: all $ui-transition ease;
    @include media-breakpoint-up(md){
      width: $infobar-width;
      right: -$infobar-width;
    }
    .close{
      @include resetButton;
      position: absolute;
      top: 10px;
      left: 10px;
      background: rgba($color-dark-green,.85) url('/assets/close.svg') no-repeat center center;
      background-size: 50% auto;
      width: 24px;
      height: 24px;
      z-index: 9;
      border-radius: 50%;
    }
    .crop-image {
      width: 100%;
      position: relative;
      &::after{
        content: '';
        width: 100%;
        height: 95px;
        background: linear-gradient(180deg, rgba(45, 49, 45, 0) 0%, #2D312D 100%);
        opacity: 0.1;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
      }
      img{
        width: 100%;
        height: auto;
      }
      .navigation{
        position: absolute;
        top: 50%;
        left: 30px;
        right: 30px;
        transform: translateY(-50%);
        display: flex;
        justify-content: space-between;
        .btn{
          width: 40px;
          height: 40px;
          padding: 0;
          margin: 0;
          background: rgba($color-dark-green,.85) url('/assets/arrow-left-white.svg') no-repeat center center;
          &.next{
            transform: rotate(180deg);
          }
        }
      }
    }
    .cost{
      display: flex;
      justify-content: space-between;
      .cost-rating{
        margin-right: 10px;
      }
      .cost-rating,
      .heading-info{
        opacity: .7;
      }
    }
    .crop-content {
      padding: 20px 15px;
      display: block;
      @include media-breakpoint-up(md){
        padding: 20px 30px;
      }
      .heading-crop{
        margin-bottom: .5em;
      }
      .rating .bars{
        justify-content: flex-start;
      }
    }
    .rate{
      display: flex;
      justify-content: space-between;
      margin: 0 0 5px;
      font-weight: 600;
      font-size: 16px;
      .label{
        font-weight: 600;
        font-size: 16px;
        display: inline;
        margin: 0;
      }
    }
    a {
      color: $color-ada-green-on-white;
      font-size: 13px;
      font-weight: 600;
      line-height: 24px;
      text-decoration: underline;
      margin-left: 8px;
    }
    .seeding-rate {
      font-weight: 600;
      em {
        display: inline-block;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
      }
    }
    .heading-info {
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 1px;
      line-height: 24px;
      margin: 0;
      font-weight: 600;
      display: inline;
    }
    .add-form {
      background: $color-internal-form;
      padding: 30px;
      .alert{
        margin: 20px 0;
      }
    }
    .add-field {
      position: relative;
      margin: 8px 0 20px;
      input {
        border: none;
        border-radius: 3px;
        background: $color-dark-white;
        font-size: 24px;
        font-weight: 400;
        line-height: 24px;
        padding: 0 20px;
        height: 60px;
        width: 100%;

        &:focus {
          outline: none;
        }
      }
      .form-control{
        color: $color-dark-green;
      }
      .toggle-units {
        position: absolute;
        top: 0;
        right: 0;
        border: none;
        border-radius: 0 3px 3px 0;
        height: 60px;
        width: 88px;
        text-align: center;
        background: $color-neon-green;
        font-size: 20px;
        line-height: 23px;
        font-weight: 600;
        color: $color-dark-green;
        &:focus {
          outline: none;
        }
        &[disabled]{
          background: rgba($color-internal-form, 0.87);
          i {
            display: none;
          }
        }
        i {
          display: block;
          position: absolute;
          bottom: 8px;
          left: 50%;
          transform: translateX(-50%);
          width: 12px;
          height: 17px;
          background: url('/assets/radio-arrow.svg') no-repeat center bottom;
          transition: all 0.2s ease-in-out;
        }
      }
      .toggle-label{
        position: absolute;
        bottom: 70px;
        right: 10px;
        font-size: 13px;
        color: $color-black;
        opacity: .5;
      }
    }
    .add-button{
      position: relative;
      padding-top: 10px;
      &::after{
        content: '';
        width: 40px;
        height: 40px;
        background: url('/assets/checkbox.svg') no-repeat center center;
        position: absolute;
        right: 15px;
        top: 22px;
        z-index: 1;
        transition: .2s;
        transform: scale(0);
      }
      &.added{
        &::after{
          transform: scale(1);
        }
      }
      .btn-primary {
        max-width: none;
        border: 1px solid rgba(44, 106, 46, 0.15);
        height: 60px;
        margin: 0;
        &:hover {
          box-shadow: 0 0 0 rgba($color-black, 0.0);
          border: 1px solid rgba(44, 106, 46, 0.45);
        }
      }
      .remove{
        @include resetButton;
        text-align: center;
        color: $color-black;
        opacity: .5;
        font-size: 13px;
        width: 100%;
      }
    }
    .crop-stats {
      padding-bottom: 40px;
    }
  }
</style>
